import { render, staticRenderFns } from "./Cardiologies.vue?vue&type=template&id=3df6d5fa&scoped=true"
import script from "./Cardiologies.vue?vue&type=script&lang=js"
export * from "./Cardiologies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df6d5fa",
  null
  
)

export default component.exports